export default "__VITE_ASSET__DxM9czux__"